import { createTheme } from '@mui/material';
import '@mui/x-data-grid/themeAugmentation';

const baseTheme = createTheme();

const ApplicationTheme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#00a63e',
      light: '#00c951',
      dark: '#008236',
      contrastText: '#fff',
    },
    secondary: {
      main: '#007be5',
      light: '#0d99ff',
      dark: '#007be5',
      contrastText: '#fff',
    },
    error: {
      main: '#dd2c00',
      light: '#d84315',
      dark: '#bf360c',
      contrastText: '#fff',
    },
  },
  typography: {
    h1: {
      fontSize: '3.75rem',
      color: '#000000',
      '@media (max-width:600px)': {
        fontSize: '2rem',
      },
      [baseTheme.breakpoints.up('md')]: {
        fontSize: '2.5rem',
      },
    },
    h2: {
      fontSize: '2.25rem',
      color: '#212121',
      '@media (max-width:600px)': {
        fontSize: '1.5rem',
      },
      [baseTheme.breakpoints.up('md')]: {
        fontSize: '2rem',
      },
    },
    h3: {
      fontSize: '2rem',
      color: '#212121',
      '@media (min-width:600px)': {
        fontSize: '1rem',
      },
      [baseTheme.breakpoints.up('md')]: {
        fontSize: '1.5rem',
      },
    },
    h4: {
      fontSize: '1.75rem',
      color: '#212121',
      '@media (min-width:600px)': {
        fontSize: '1rem',
      },
      [baseTheme.breakpoints.up('md')]: {
        fontSize: '1.25rem',
      },
    },
    body1: {
      fontSize: '1.25rem',
      color: '#212121',
      lineHeight: 'calc(1.75 / 1.25)',
      '@media (min-width:600px)': {
        fontSize: '1rem',
      },
    },
    body2: {
      fontSize: '1rem',
      color: '#212121',
      lineHeight: 'calc(1.75 / 1.25)',
      '@media (min-width:600px)': {
        fontSize: '0.75rem',
      },
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        // Name of the slot
        root: {
          textTransform: 'none',
          minWidth: 'inherit'
        },
      },
    },
    MuiAlert: {
      styleOverrides: {
        // Name of the slot
        root: {
          display: 'flex',
          alignItems: 'center',
          '& .MuiAlert-icon': { padding: 0 },
          '& .MuiAlert-message': { padding: 0 },
        },
        filledInfo: {
          backgroundColor: '#e5f6fd',
          color: '#014361',
        },
        filledSuccess: {
          backgroundColor: '#edf7ed',
          color: '#1e4620',
        },
        filledError: {
          backgroundColor: '#fdeded',
          color: '#5f2120',
        },
        filledWarning: {
          backgroundColor: '#fff4e5',
          color: '#663c00',
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        // Name of the slot
        root: {
          input: {
            padding: '7px 10px',
            height: 'unset',
          },
        },
      },
    },
    MuiFormControl: {
      styleOverrides: {
        root: {
          marginBottom: '30px',
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          marginTop: 0,
          '& .MuiInputLabel-outlined': {
            // lineHeight: '12px',
            top: '-3px',
            '@media (min-width:600px)': {
              fontSize: '14px',
            },
          },
          '& .MuiFormLabel-root': {
            '-webkit-transform': 'translate(14px, 12px) scale(1)',
            '-moz-transform': 'translate(14px, 12px) scale(1)',
            '-ms-transform': 'translate(14px, 12px) scale(1)',
            transform: 'translate(14px, 12px) scale(1)',
          },
          '& .MuiInputLabel-outlined.MuiInputLabel-shrink': {
            // top: '3px',
            '-webkit-transform': 'translate(14px, -1.5px) scale(0.75)',
            '-moz-transform': 'translate(14px, -1.5px) scale(0.75)',
            '-ms-transform': 'translate(14px, -1.5px) scale(0.75)',
            transform: 'translate(14px, -1.5px) scale(0.75)',
          },
          '& .MuiFormHelperText-root': {
            marginLeft: 0,
            marginRight: 0,
            fontSize: '10px',
          },
        },
      },
    },
    MuiDataGrid: {
      styleOverrides: {
        root: {
          backgroundColor: '#ffffff',
          '& .MuiDataGrid-columnHeader': {
            backgroundColor: '#00a651', // ✅ your green header
            color: '#fff',
            fontWeight: 'bold',
            fontSize: '0.9rem',
          },
          '& .MuiDataGrid-row': {
            alignItems: 'center',
          },
          '& .MuiDataGrid-cell': {
            display: 'flex',
            alignItems: 'center',
          },
          '& .MuiDataGrid-row:nth-of-type(odd)': {
            backgroundColor: '#f9f9f9', // ✅ light grey odd rows
          },
          '& .MuiDataGrid-row:hover': {
            backgroundColor: '#eef6ee',
          },
          '& .MuiDataGrid-footerContainer': {
            borderTop: '1px solid #e0e0e0',
            backgroundColor: '#fff',
          },
        },
      },
    },
  },
});

export default ApplicationTheme;
